<template>
  <div class="page flex-col-c">
    <div v-if="icon" class="w100">
      <el-image :src="icon" class="w100" fit="cover" style="height:200px"/>
    </div>

    <div class="pad_20 qysq">
      <h1 class="fon_20 wei">合作申请</h1>
      <div class="fon_16 color_9"><span>请认真填写以下信息。提交成功后，我们的工作人员会尽快与您联系。</span></div>
      <div class="pad_l_10 mar_t15">
        <el-form :model="form" label-position="left">
          <div class="title">联系信息</div>
          <el-form-item :required="true" :label-width="formLabelWidth" label="申请合作城市：" >
            <div class="flex-bet">
              <div class="flex-g-1" @click="showPicker=true">
                <div
                  :style="form.name?'color:#000':'color:#c0c4cc'"
                  style="width:200px;padding-left:15px;color:#c0c4cc"
                >
                  <span class="c3 f32" @click="showPicker=true">{{ form.name||'请选择城市' }}</span>
                </div>
              </div>
              <div class="flex-g-0 color_9 curs" @click="showPicker=true">
                >
              </div>
            </div>
          </el-form-item>
          <el-form-item :required="true"  :label-width="formLabelWidth" label="联系人：">
            <el-input v-model="form.userName" placeholder="请输入联系人"/>
          </el-form-item>
          <el-form-item :required="true" :label-width="formLabelWidth" label="联系电话：" >
            <el-input v-model="form.userTel" type="number" placeholder="请输入联系手机号"/>
          </el-form-item>
          <el-form-item  :label-width="formLabelWidth" label="联系邮箱：" >
            <el-input v-model="form.email" placeholder="请输入联系邮箱"/>
          </el-form-item>
          <el-form-item :required="true" :label-width="formLabelWidth" label="预计投入资金：" >
            <el-input v-model="form.money" type="number" placeholder="请输入数据（单元:万元）"/>
          </el-form-item>
        </el-form>
      </div>
      <el-button :style="{backgroundColor:color,color:fontColor}" class="btn" @click="submit">提交申请</el-button>
    </div>
    <Popup v-model="showPicker" :style="{ height: '300px' ,width:'100%'}" position="bottom">
      <Picker :columns="columns" value-key="label" show-toolbar title="请选择区域" @cancel="showPicker=false" @confirm="selectCity"/>
    </Popup>
  </div>

</template>

<script>
import Popup from 'vant/lib/popup'
import 'vant/lib/popup/style'
import Picker from 'vant/lib/picker'
import 'vant/lib/picker/style'
export default {
  name: 'Person',
  components: {
    Popup, Picker
  },
  data() {
    return {
      showPicker: false,
      formLabelWidth: '136px',
      form: {
        name: '',
        // city: '',
        email: '',
        money: '',
        userName: '',
        userTel: ''
      },
      columns: [

      ],
      uniacid: '',
      icon: '',
      color: '',
      fontColor: ''
    }
  },
  created() {
    document.title = this.$route.name
    if (this.$route.query.uniacid) {
      this.uniacid = this.$route.query.uniacid
      this.form.uniacid = this.$route.query.uniacid
      this.init()
      this.getConfigM()
      this.getConfigM2()
      this.getConfigM3()
      console.log(1)
    }
  },
  methods: {
    init() {
      this.$api.getCity({ type: 2 ,uniacid: this.uniacid }).then(res => {
        this.columns = res.data
      })
      if (this.$route.query.uniacid) {
        this.form.uniacid = this.$route.query.uniacid
      }
    },
    getConfigM() {
      this.$api.getConfig({ ident: 'regionWithdrawal', uniacid: this.uniacid }).then(res => {
        this.icon = res.data.icon ? res.data.icon : ''
      })
    },
    getConfigM2() {
      this.$api.getConfig({ ident: 'style', uniacid: this.uniacid }).then(res => {
        this.color = res.data.color
        this.fontColor = res.data.fontColor
      })
    },
    getConfigM3() {
      this.$api.getConfig({ ident: 'customName', uniacid: this.uniacid }).then(res => {
        document.title = res.data.regionalAgent ? res.data.regionalAgent : '申请代理'
      })
    },
    selectCity(e) {
      this.form.name = e.join(' ')
      this.showPicker = false
    },
    submit() {
      if(this.form.name==''){
        this.$message({type: 'error', message: '请选择合作区域'})
        return
      }else if(this.form.userName==''){
        this.$message({type: 'error', message: '请输入联系人姓名'})
        return
      }else if(this.form.userTel==''){
        this.$message({type: 'error', message: '请输入联系人手机号'})
        return
      }else if(this.form.money==''){
        this.$message({type: 'error', message: '请输入预计投入资金'})
        return
      }
      this.$api.regionSave(this.form).then(res => {
        this.$message({
          type: 'success',
          message: `${res.msg}: 提交申请成功`
        })
        this.form = {
          name: '',
          email: '',
          money: '',
          userName: '',
          userTel: ''
        }
        this.init()
      })
    }

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .title{
    position: relative;
		font-size: 18px;
		font-weight: bold;
		padding-left: 10px;
		margin-left: -10px;
  }
  .title::after {
		content: '';
		position: absolute;
		left: 0;
		top: 50%;
		transform: translateY(-50%);
		width: 3px;
		height: 16px;
		background: #FFD24D;
	}
  .btn{
    width: 100%;
		font-size: 14px;
		border-radius: 5px;
    background-color: #FFD24D;
    border-color: #FFD24D;
    border: none;
	}
  .qysq >>> .el-form-item__label {
    font-size: 16px;
  }
  .qysq >>> .el-input {
    font-size: 16px;
  }
  .qysq >>> .el-form-item__content {
    font-size: 16px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/person-apply.vue